const validateIBAN = IBANString => {
  const iban = IBANString.replace(/\s/g, '')
    .trim()
    .toUpperCase();
  if (iban.length !== 24) {
    return false;
  }
  const findIBANCharIndex = char => 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.search(char) + 10;

  const module97 = value => {
    const parts = Math.ceil(value.length / 7);
    let remainer = '';
    for (let i = 1; i <= parts; i += 1) {
      remainer = String(parseFloat(remainer + value.substr((i - 1) * 7, 7)) % 97);
    }
    return remainer;
  };
  let ibanaux = iban
    .substring(0, 2)
    .split('')
    .map(findIBANCharIndex)
    .join('')
    .concat(iban.substring(2));
  ibanaux = ibanaux.substring(6).concat(ibanaux.substring(0, 6));
  return Number(module97(ibanaux)) === 1;
};

export { validateIBAN as default };
